import React from 'react';
import { Row, Col, Accordion } from '@everlywell/leaves';
import { CTA } from 'utils/types';

import ewAnalytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';

import * as S from './styles';

export interface Props {
  secondaryHeadline: string;
  secondaryCtaList: CTA[];
}

export const SecondaryCTASection: React.FC<Props> = ({
  secondaryHeadline,
  secondaryCtaList,
}) => {
  const handleClick = (category: string) => {
    ewAnalytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: ANALYTICS.LABELS.HOMEPAGE_HERO_CATEGORY,
        Category: category,
      },
    });
  };
  return (
    <div data-testid="secondaryCtaSection">
      <S.SecondaryContainerDesktop>
        <Row center="xs">
          <Col xs>
            <S.SecondaryHeadline>{secondaryHeadline}</S.SecondaryHeadline>
          </Col>
        </Row>
        <Row>
          {secondaryCtaList.map(cta => (
            <Col xs key={cta.text}>
              <S.SecondaryCTA
                href={cta.url}
                onClick={() => handleClick(cta.text)}
              >
                <S.SecondaryCTAText>{cta.text}</S.SecondaryCTAText>
              </S.SecondaryCTA>
            </Col>
          ))}
        </Row>
      </S.SecondaryContainerDesktop>
      <S.SecondaryContainerMobile>
        <Row>
          <Col xs>
            <Accordion.Wrapper>
              <Accordion.Item>
                <S.AccordionHeading>{secondaryHeadline}</S.AccordionHeading>
                <Accordion.Child>
                  {(open: boolean) => (
                    <S.AccordionChildContent>
                      {secondaryCtaList
                        ? secondaryCtaList.map(cta => (
                            <S.SecondaryCTA
                              href={cta.url}
                              key={cta.text}
                              onClick={() => handleClick(cta.text)}
                              tabIndex={open ? 0 : -1}
                            >
                              <S.SecondaryCTAText>
                                {cta.text}
                              </S.SecondaryCTAText>
                            </S.SecondaryCTA>
                          ))
                        : null}
                    </S.AccordionChildContent>
                  )}
                </Accordion.Child>
              </Accordion.Item>
            </Accordion.Wrapper>
          </Col>
        </Row>
      </S.SecondaryContainerMobile>
    </div>
  );
};

export default SecondaryCTASection;
